import { ChallengeStats, EngineState, ShotLane, ShotOutcome, Vec3 } from './types';

export const FIRST_RUN_UP_DURATION_MS = 1120;
export const REPEAT_RUN_UP_DURATION_MS = 760;
export const FLIGHT_DURATION_MS = 820;
export const RESULT_DURATION_MS = 720;
export const TOTAL_SHOTS = 5;
export const UI_SYNC_INTERVAL_MS = 100;
export const POWER_SYNC_INTERVAL_MS = 48;
export const MAX_RESUME_DELTA_MS = 48;
export const CAMERA = { x: 0, y: 1.68, z: 0.2 };
export const DEFAULT_AIM = 0.5;
export const CHARGE_MIN_POWER = 0.08;
export const CHARGE_MAX_POWER = 0.96;
export const CHARGE_FILL_DURATION_MS = 900;
export const GOAL_MOUTH_START_RATIO = 0.23;
export const GOAL_MOUTH_END_RATIO = 0.77;

export const laneOrder: ShotLane[] = ['left', 'center', 'right'];

export const laneLabels: Record<ShotLane, string> = {
  left: 'Left',
  center: 'Center',
  right: 'Right',
};

export const laneTargets: Record<ShotLane, Vec3> = {
  left: { x: -5.1, y: 2.6, z: 21.1 },
  center: { x: 0.12, y: 1.65, z: 21.1 },
  right: { x: 5.1, y: 1.08, z: 21.1 },
};

export const GOAL_FRAME = {
  backZ: 22.1,
  crossbarY: 3.55,
  frontZ: 20.2,
  halfWidth: 5.6,
} as const;

export const outcomeColors: Record<ShotOutcome, string[]> = {
  goal: ['#c7d2fe', '#60a5fa', '#34d399', '#f8fafc'],
  save: ['#bfdbfe', '#38bdf8', '#f8fafc'],
  miss: ['#fde68a', '#f97316', '#f8fafc'],
};

export const shotBandThresholds = {
  redLowMax: 0.14,
  greenStart: 0.54,
  greenEnd: 0.63,
  redHighMin: 0.88,
} as const;

export const initialStats = (): ChallengeStats => ({
  attempts: 0,
  goals: 0,
  saves: 0,
  misses: 0,
  streak: 0,
  bestStreak: 0,
  perfectGoals: 0,
});

export const createInitialEngine = (): EngineState => ({
  phase: 'idle',
  phaseStartedAtMs: 0,
  stats: initialStats(),
  shot: null,
  particles: [],
  nextShotId: 1,
  appliedResultShotId: null,
  aim: DEFAULT_AIM,
  chargeStartedAtMs: null,
});
